<template>
  <div class="navbar bg-white breadcrumb-bar">
    <div class="slot1 scroll-x">
      <button class="btn btn-sm btn-primary" :disabled="disableBack" @click="back">
        <b-icon icon="arrow-left"></b-icon>
      </button>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li v-for="(item, index) in $route.meta.breadcrumb" :key="index" class="breadcrumb-item">
            <router-link
              v-if="index < $route.meta.breadcrumb.length - 1"
              :to="item.route"
            >{{ item.title }}</router-link>
            <span v-else>{{ item.title }}</span>
          </li>
        </ol>
      </nav>
      <slot name="slot1" />
    </div>

    <div class="slot2">
      <slot />
    </div>

    <div class="slot3">
      <slot name="slot3" />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    disableBack() {
      if (!this.$route.meta.breadcrumb) return true
      if (this.$route.meta.breadcrumb.length > 1) {
        return false
      }
      return true
    },
  },
  methods: {
    back() {
      this.$router.back()
    },
  },
}
</script>

<style>
@media (max-width: 400px) {
  /* .navbar.breadcrumb-bar  {
    display: block;
  } */
  /* .slot1.scroll-x button.btn, .slot1.scroll-x .breadcrumb-item a, .slot1.scroll-x .breadcrumb-item span{
    border-radius: 0!important;
    margin: 0;
    padding: 0.25rem 1rem;
    min-width: 50px;
} */
}
.navbar.breadcrumb-bar {
  display: flex;
  justify-content: space-between;

    white-space: nowrap;
}
div.slot1 * {
  display: inline-block;
}
.breadcrumb-item + .breadcrumb-item:before {
  display: none;
}
.breadcrumb span {
  font-weight: 600;
}
.breadcrumb-bar {
  justify-content: flex-start;
}

.breadcrumb-bar .btn {
  padding: 1px 10px;
  margin-right: 5px;
}

.breadcrumb-bar a {
  background: #00878f;
  padding: 2px 10px;
  border-radius: 4px;
  color: white;
}

.breadcrumb span {
  font-weight: 600;
  background: #efefef;
  padding: 1px 10px;
  border-radius: 4px;
}
</style>
